var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper_wide section_content",class:{offline: !_vm.isOnline}},[_c('div',{staticClass:"frame_center"},[_c('Form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }